Other orders saved localy:
<div *ngFor="let ord of (allOrders$ | async)">
    <div *ngIf="currentOrderId !== ord._id">
        <button mat-button (click)="goToOrder(ord)">{{ord._id}}</button>
        <button mat-button (click)="deleteOrder(ord)">Usuń</button>
    </div>

</div>